<template>
  <p v-if="lang === 'en'" class="muted note">My articles are written in French.</p>
  <ul class="alist">
    <li v-for="a in items" :key="a.url">
      <a :href="a.url" hreflang="fr" target="_blank" rel="noopener">
        <time :datetime="a.date">{{ t(a.label) }}</time>
        <span><span class="t">{{ a.title }}</span><small>{{ t(a.text) }}</small></span>
        <span class="go"><ArrowUpRight /></span>
      </a>
    </li>
  </ul>
</template>

<script>
import { ArrowUpRight } from "lucide-vue-next";
import { useI18n } from "@/i18n";

export default {
  name: "ArticleList",
  components: { ArrowUpRight },
  props: { items: { type: Array, required: true } },
  setup: () => useI18n(),
};
</script>

<style scoped>
.note {
  margin: -12px 0 12px;
}
</style>
